import { ImageInfo } from 'expo-image-picker'

export const getFileType = (file : ImageInfo) : string => {
  // get text between data:image/ and ;base64 from file.uri
  const fileType = file.uri.split('data:image/')[1].split(';base64,')[0]
  return fileType
}
